import pick from "../__compat__/lodash/pick.mjs.mjs";
import pickBy from "../__compat__/lodash/pickBy.mjs.mjs";
export const pickComponentCommonProps = (props) => pick(props, ['className', 'data-testid', 'id']);
export const pickAriaProps = (props) => pickBy(props, (_, key) => key.startsWith('aria-'));
export const pickDataProps = (props) => pickBy(props, (_, key) => key.startsWith('data-'));
//# sourceMappingURL=commonProps.mjs.mjs.map